<template id="salesmanDashboard">
  <section>
    <div class="card "
 :class="[
         $store.state.bannerStatus ? 'banner-true' : 'banner-false',
    !$store.state.fixedScreen ? 'fixed-screen-width' : ''
    ]">
      <div class="card-header d-flex justify-content-between p-2">
        <div class="d-flex flex-wrap justify-content-start">
          <div class="mr-auto">
            <strong>
              <i :class="screenletTitleInfo ? 'fa fa-info-circle custom-icon mr-1' : 'fa fa-info-circle mr-1'"
                 ref="tooltipIcon"
                 v-b-tooltip.hover.right.html="{ title: screenletTitleInfo, customClass: 'my-custom-tooltip', autoHide: false }"
                 @mouseenter="showTooltip"
                 @mouseleave="hideTooltip">
              </i>
              {{ screenName }}
            </strong>
            <button class="back-button" @click="reloadIframe">
              <i class="fa fa-arrow-left"></i>
            </button>
          </div>
          <div v-for="(key,idx) of screenletListboxDim" :key="idx">
            <div class="mr-auto p-2 ">
              <span>{{ SLlistboxDimBizName[idx] }}:</span>
              <div class="anyWhichWay" v-if="screenletListboxType === 'anyWhichWay'">

                <multiselect
                    v-model="filter[key]"
                    :options="listBoxOptions[key] || []"
                    :multiple="false"
                    select-label="Select"
                    deselect-label="Unselect"
                    :limit="1"
                    :clear-on-select="false"
                    :preserve-search="true"
                    @input="optionSelected(filter)"
                >
                </multiselect>
              </div>
              <div class="freeForm" v-else>
                <multiselect
                    v-model="filter[key]"
                    :options="getFilteredValues(key)"
                    :multiple="false"
                    select-label="Select"
                    deselect-label="Unselect"
                    :limit="1"
                    :clear-on-select="false"
                    :preserve-search="true"
                    @input="menuPath==='/post-load' ? toggleButton() : optionSelected(filter)"
                >
                </multiselect>

              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="card-body" :class="[
         $store.state.bannerStatus ? 'banner-true' : 'banner-false',
    !$store.state.fixedScreen ? 'fixed-screen-width' : ''
    ]">
        <div v-bind:style="{'overflow': screenletCardStyle==='flex-row-overflow' ? 'auto' : 'none', height: '82vh'}"
             v-bind:class="screenletCardClass" style="height: 100%;">
          <div v-if="!hasValidStore" class="select-store-msg">
            <p>Please select the Store Name</p>
          </div>

          <!-- ✅ Iframe -->
          <iframe
              v-if="hasValidStore"
              :key="iframeKey"
              :src="iframeSrc"
              width="100%"
              frameBorder="0">
          </iframe>
          <iframe
              v-if="!hasValidStore"
              :key="iframeKey"
              :src="iframeSrc"
              width="100%"
              frameBorder="0">
          </iframe>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import _ from 'lodash'
import axios from 'axios';
import Multiselect from 'vue-multiselect/src/Multiselect'
import {isDescendant} from "@/common/functions";

export default {
  name: "salesmanDashboard",

  components: {Multiselect},
  props: {
    screenlet: Number,
    sl: Object,
    scrnPropTime: Date,
    screenletId: String
  },
  watch: {
    $props: {
      handler() {
        this.loadListbox()
      },
      deep: true,
      immediate: true,
    },
    iframeSrc(newSrc) {
      this.iframeKey = `${newSrc}?t=${Date.now()}`;
    }
  },
  mounted() {
    this.iframeKey = `${this.iframeSrc}?t=${Date.now()}`;
  },
  data: () => ({
    baseUrl: "",
    iframeKey: 0, // Used to force iframe reload
    optionValues: ['a', 'b'],
    menuPath: '',
    filterValues: [],
    searching: false,
    vizData: [],
    vizDataRowCol: {},
    screenName: '',
    time3: '',
    rows: [],
    x: {},
    filter: {},
    //x: {"d3l1_name":"All","d6l1_name":"All"},//need to revisit to make it dynamic
    propTime: null,
    y: {},
    li: 0,
    screenletListboxCount: null,
    screenletListboxCountT: 2,
    orderbyTextJson: {},
    screenletListboxDim: {},
    dateRangeFilterFlag: '',
    SLlistboxDimBizName: {},
    currentMenuActionIconsData: {},
    currentMenuListboxData: {},
    dateRangeFilterShortcuts: {},
    shortcuts: [],
    temp: [],
    promises: [],
    rowColMap: {},
    selectedKey: null,
    selectedValue: null,
    dataset: [],
    screenletListboxType: null,
    br: null,
    sm: null,
    filters: [{
      nameAll: 'Select all',
      nameNotAll: 'Deselect all',
      func() {
        return true;
      },
    }],
    options: {
      multi: true,
      groups: false,
      labelName: 'label',
      labelList: 'elements',
      groupName: 'title',
      cssSelected: option => (option.selected ? {'background-color': '#5764c6'} : ''),
    },
    screenletListboxDefault: {},
    screenletCardStyle: '',
    screenletTitleInfo: '',
    listBoxOptions: {},
    listBoxCache: {},
    isToggled: false,
    authToken: "",
    userId:'',
  }),
  computed:
      {
        hasValidStore() {
          const store = this.filter?.store_name;
          if (!store) return false;

          // Case 1: multiselect returns object
          if (typeof store === "object") {
            return !!store.value || !!store.id;
          }

          // Case 2: string like "ABC Store (12345)"
          if (typeof store === "string") {
            return /\((\d+)\)/.test(store);
          }

          return false;
        },

        extractedStoreId() {
          const store = this.filter?.store_name;
          if (!store) return "";

          // ✅ Object case (BEST)
          if (typeof store === "object") {
            return store.value || store.id || "";
          }

          // ✅ String case (fallback)
          if (typeof store === "string") {
            const match = store.match(/\((\d+)\)/);
            return match ? match[1] : "";
          }

          return "";
        },

        iframeSrc() {
          if (!this.hasValidStore) return "";

          return `${this.baseUrl}/?mtm=FFA-FW&store_id=${this.extractedStoreId}&requestor=${this.userId}&sessiontoken=${this.authToken}`;
        }
        ,
        screenletCardClass() {
          if (this.screenletCardStyle === 'card-deck') {
            return 'card-deck m-2'
          } else if (this.screenletCardStyle === 'flex-row-overflow') {
            return 'd-flex flex-row m-2'
          } else if (this.screenletCardStyle === 'flex-no-wrap') {
            return 'm-2'
          } else {
            return 'card-deck m-2'
          }
        }
        ,
        getFilteredValues() {
          return (key1) => {
            return _.uniq(this.dataset.map(kv => kv[key1]))
                .sort((a, b) => {
                  const isDateA = this.isDateRelated(a);
                  const isDateB = this.isDateRelated(b);

                  if (isDateA && isDateB) {
                    // Both are date-related, sort in descending order
                    return this.parseDate(b) - this.parseDate(a);
                  }
                });
          };
        }
        ,
        // eslint-disable-next-line vue/return-in-computed-property
        applyScreenletListboxDefault() {
          let defaultValues = {}; // Initialize an object to store the default values
          if (this.screenletListboxDefault) {
            if (Object.keys(this.screenletListboxDefault).length > 0) {
              Object.keys(this.screenletListboxDefault).forEach((key) => {
                /*
                console.log("listBoxOptions", JSON.stringify(this.listBoxOptions));
                console.log("screenletListboxDefault", this.screenletListboxDefault[key]);*/
                defaultValues[key] = this.screenletListboxDefault[key]; // Populate the defaultValues object
              });
            }
          }
          return defaultValues;
        }
        ,
      }
  ,
  async created() {

    let restrictedMenu = this.$store.state.user.userRoleRestriction.menuAccessInclusionArray || []
    let exclusionArray = this.$store.state.user.userRoleRestriction.menuAccessExclusionArray || [];
    const menuTree = this.$store.state.menuMasterData.filter(m => m.parentMenuId === 'Root') || []

    // Handle empty/undefined/null/["[]"] cases - all menus allowed
    const isAllMenusAllowed = !restrictedMenu ||
        restrictedMenu.length === 0 ||
        (restrictedMenu.length === 1 && restrictedMenu[0] === "[]")

    if (!isAllMenusAllowed) {
      const currentMenuId = this.$route.params.menuId
      const currentSubmenuId = this.$route.params.submenuId

      // Only check menu restrictions for routes that have these parameters
      if (currentMenuId || currentSubmenuId) {
        // Check if current IDs are in exclusion array
        const isExcluded = exclusionArray.includes(currentMenuId) ||
            exclusionArray.includes(currentSubmenuId)
        // If NEITHER menuId NOR submenuId is in the allowed list, block access
        // Check whether current IDs are directly allowed or descendants of allowed ones
        const isAllowed =
            restrictedMenu.includes(currentMenuId) ||
            restrictedMenu.includes(currentSubmenuId) ||
            isDescendant(menuTree, restrictedMenu, currentMenuId) ||
            isDescendant(menuTree, restrictedMenu, currentSubmenuId);

        if (!isAllowed || isExcluded) {
          window.alert("Invalid action, request please contact your Administrator")
          // You might want to redirect to user-restrict page here as well
          await this.$router.push('/user-restrict')
          return; // Stop execution
        }
      }
    }
    this.listenToRouter()
    this.authToken = this.$store.state.authToken
    this.userId = this.$store.state.user.userId
    console.log("authToken", this.authToken)
    console.log("userId", this.userId)
  }
  ,

  methods: {
    reloadIframe() {
      // Update iframe key to force reload
      this.iframeKey += 1;
    }
    ,
    showTooltip() {
      const tooltip = this.$refs.tooltipIcon._tooltip;
      if (tooltip) {
        tooltip.show(); // Use the show method provided by Bootstrap-Vue
      }
    }
    ,
    hideTooltip() {
      const tooltip = this.$refs.tooltipIcon._tooltip;
      if (tooltip) {
        tooltip.hide(); // Use the hide method provided by Bootstrap-Vue
      }
    }
    ,
    async makeListBoxOptions() {
      let listboxData = this.dataset
      console.clear()

      const makeOptions = (records, filterKeys, cacheKey) => {
        //make distinct values of each col
        //total cols = 4

        //cacheKey = simply, length of row + filterKeys

        const getDistinctColValues = () => {

          //for each key, we make a set to hold distinct values
          let localFilters = Object.fromEntries(
              filterKeys.map(k => [k, new Set()])
          )

          //parse through each record
          for (let row of records) {
            //for every filter-key, we add to set, this will de-dup the data
            for (let fk of filterKeys) {
              localFilters[fk].add(row[fk])
            }
          }

          //convert to a map of {k1: [distnct values for k1], k2: [distinct values for k2] .... etc}
          return Object.fromEntries(Object.entries(localFilters).map(x => {
            return [x[0], [...x[1]].sort()]
          }))
        }

        let fromCache = false; //this.listBoxCache[cacheKey]
        //let fromCache = false
        if (cacheKey && fromCache) {
          return fromCache;
        } else {
          // let ts = new Date().getTime()
          let value = getDistinctColValues();
          this.listBoxCache[cacheKey] = value;
          return value;

        }

      }

      const applyNextFilter = (currentFilter, restOfFilters, appliedFilters) => {

        let colSelected = currentFilter[0],
            colValues = currentFilter[1];

        //say 3 filters
        //salesman, brand, store
        //when nothing is selected, then distinct values of each can be used (default)
        //say one is selected, then we use that and select distinct values for rest
        //say two is selected, then use both to select distinct values for rest


        //filter records based on applied filters
        let listboxdataCopy = [...listboxData]

        for (let restFilter of restOfFilters) {
          if (restFilter[1].length > 0) {
            listboxdataCopy = listboxdataCopy.filter(x => restFilter[1].indexOf(x[restFilter[0]]) > -1);
          }
        }

        let optionsAfterRest = makeOptions(
            listboxdataCopy,
            [colSelected],
            [...Object.entries(restOfFilters), currentFilter]
                .map(([key, val]) => `${key}:${Array.isArray(val) ? val.join('-') : val}`)
                .join()
        )


        //select records, by applying the current filter
        let recordsAfterFilter = listboxdataCopy.filter(x => colValues.indexOf(x[colSelected]) > -1);

        //from filters, remove the current filter, and previously applied filters
        let filterRemainingKeys = Object
            .keys(listboxData[0])
            .filter(x => x !== colSelected)
            .filter(x => !appliedFilters.map(y => y[0]).includes(x))

        //now we would have gotten, distinct col values for remaining filter, based on remaining data
        let options = makeOptions(
            recordsAfterFilter,
            filterRemainingKeys,
            Object.entries(this.filter)
                .map(([key, val]) => `${key}:${Array.isArray(val) ? val.join('-') : val}`)
                .join()
        )

        return { ...options, ...optionsAfterRest }

      }

      if (this.dataset.length > 0) {

        //if filter values are selected, then apply
        let initialFilterValues = makeOptions(listboxData, Object.keys(listboxData[0]), "ALL")
        let nextFilter = null;
        //iterate through each filter
        let filterEntries = Object.entries(this.filter);
        let appliedFilters = []
        for (let currFilter of filterEntries) {

          let restOfFilters = filterEntries.filter(x => x[0] !== currFilter[0])

          //if the filter is selected
          if (currFilter[1].length > 0) {

            let prevFilter = {...(nextFilter || initialFilterValues)}
            let appliedFilter = applyNextFilter(
                currFilter,
                restOfFilters,
                appliedFilters
            )
            appliedFilters.push(currFilter)

            nextFilter = {...prevFilter, ...appliedFilter}
          }

          //else, skip this filter
        }
        return nextFilter || initialFilterValues

      } else {
        return {}

      }
    }
    ,
    async optionSelected(x) {
      this.listBoxOptions = await this.makeListBoxOptions()
      this.sortDateRelatedObjects(this.listBoxOptions);
      console.log("this.listBoxOptions", this.listBoxOptions);
      if (this.menuPath === '/post-load') await this.toggleButton()
      if (this.isToggled === false && this.menuPath !== '/post-load') await this.loadSummary(x)
      return true
    }
    ,
    toggleButton: async function () {
      let element = document.getElementById("button");
      element.classList.remove("btn-success")
      element.classList.add("btn-warning");
    }
    ,

    isDateRelated(value) {
      if (!value) return false;

      const fiscalYearPattern = /^\d{6}$/; // e.g., 202324
      const yearPattern = /^\d{4}$/; // e.g., 2023
      const fullDatePattern = /^\d{8}$/; // e.g., 20231115
      const dashDatePattern = /^\d{4}-\d{2}$/; // e.g., 2023-11
      const dashFullDatePattern = /^\d{4}-\d{2}-\d{2}$/; // e.g., 2023-11-15

      // Pattern for month names (e.g., Jan, January, etc.)
      const monthPattern = /^(jan(uary)?|feb(ruary)?|mar(ch)?|apr(il)?|may|jun(e)?|jul(y)?|aug(ust)?|sep(tember)?|oct(ober)?|nov(ember)?|dec(ember)?)$/i;

      return (
          fiscalYearPattern.test(value) ||
          yearPattern.test(value) ||
          fullDatePattern.test(value) ||
          dashDatePattern.test(value) ||
          dashFullDatePattern.test(value) ||
          monthPattern.test(value)
      );
    }
    ,

    parseDate(value) {
      if (!value) return 0;

      // Fiscal year format (YYYYMM)
      if (/^\d{6}$/.test(value)) {
        return parseInt(value, 10);
      }

      // Year format (YYYY)
      if (/^\d{4}$/.test(value)) {
        return parseInt(value, 10);
      }

      // Full date format (YYYYMMDD)
      if (/^\d{8}$/.test(value)) {
        return new Date(
            parseInt(value.slice(0, 4), 10), // Year
            parseInt(value.slice(4, 6), 10) - 1, // Month (0-based)
            parseInt(value.slice(6, 8), 10) // Day
        ).getTime();
      }

      // Dash-separated year-month format (YYYY-MM)
      if (/^\d{4}-\d{2}$/.test(value)) {
        const [year, month] = value.split('-').map(Number);
        return new Date(year, month - 1, 1).getTime(); // First day of the month
      }

      // Dash-separated full date format (YYYY-MM-DD)
      if (/^\d{4}-\d{2}-\d{2}$/.test(value)) {
        const [year, month, day] = value.split('-').map(Number);
        return new Date(year, month - 1, day).getTime();
      }

      // Month name (Jan, January, etc.)
      const monthMap = {
        jan: 0, january: 0,
        feb: 1, february: 1,
        mar: 2, march: 2,
        apr: 3, april: 3,
        may: 4,
        jun: 5, june: 5,
        jul: 6, july: 6,
        aug: 7, august: 7,
        sep: 8, september: 8,
        oct: 9, october: 9,
        nov: 10, november: 10,
        dec: 11, december: 11
      };

      const normalizedValue = value.trim().toLowerCase();
      for (const [key, month] of Object.entries(monthMap)) {
        // if (normalizedValue === key.toLowerCase()) {
        //   const currentYear = new Date().getFullYear();
        //   return new Date(currentYear, month, 1).getTime(); // Return timestamp for the first day of the month
        // }
        if (normalizedValue === key.toLowerCase()) {
          return month; // Return the numeric month index
        }
      }

      return 0; // Default for non-date-related values
    }
    ,


    fetchListboxData: async function (sqlId) {
      let res = await axios.get('/api/fetchListboxData/' + sqlId)
      const removeEmptyOrNull = (obj) => {
        Object.keys(obj).forEach(k =>
            (obj[k] && typeof obj[k] === 'object') && removeEmptyOrNull(obj[k]) ||
            (!obj[k] && obj[k] !== undefined) && delete obj[k]
        );
        return obj;
      };
      let listboxData = res.data
      this.dataset = removeEmptyOrNull(listboxData) //removes the null and empty values in the resultset
      //convert set of values into an array using array.from
      //this.optionValues[index] = Array.from(new Set(resData.map(c => c.dim1).filter(x => x != null)))
      //return temp
      this.filter = Object.fromEntries(
          Object.keys(listboxData[0]).map(k => {
            return [k, []]
          })
      )

      this.listBoxOptions = await this.makeListBoxOptions()
      this.sortDateRelatedObjects(this.listBoxOptions);
    }
    ,

    loadListbox: async function () {

      let submenuParam = this.$route.params.submenuId
      // await this.loadFilters();
      await this.$store.dispatch("loadState")
      this.screenName = this.$store.state.menuMasterFlat.filter(m => m.menuId === submenuParam).map(m => m.menuName)[0]
      let menuMasterData = this.$store.state.menuMasterFlat.filter(m => m.menuId === submenuParam)
      console.log("menuMasterData", menuMasterData)
      if (menuMasterData.length === 0) {
        setTimeout(() => {
          let url;

          const {homeDashboardMenuId} = this.$store.state.user;
          const roleLevelMenuId = this.$store.state.userRoleRestriction.homeDashboardMenuId;

          if (!homeDashboardMenuId) {
            url = roleLevelMenuId || '/';
            console.log("Role level dashboard");
          } else {
            url = homeDashboardMenuId || '/';
            console.log("User level dashboard");
          }

          if (!url.includes('/')) {
            // to do need to re-look this logic
            // (checking if it is just a menu id without / then re-direct to home page)
            url = '/'
          }
          this.$router.push(url)
        }, 5000);
      }
      this.menuPath = menuMasterData[0].menuPath

      let menuData = this.$store.state.fwConfigMenuScreenRender
      console.log("menuData", menuData);
      let columnMetadata = this.$store.state.colummnMetaData
      let actionIconsData = this.$store.state.actionIcons
      let listboxData = this.$store.state.listbox
      let currentMenuData = [];
      if (this.screenletId) {
        currentMenuData = menuData.filter(r => r.menuId === submenuParam && r.screenletInstanceId === this.screenletId)
      } else {
        currentMenuData = menuData.filter(r => r.menuId === submenuParam)
      }

      console.log("currentMenuData[0]", currentMenuData[0]);
      //screenlet title info
      this.screenletTitleInfo = currentMenuData[0].screenletTitleInfo

      this.baseUrl = currentMenuData[0].screenTitleDpName


      let screenletActionIconsSyspkArray = currentMenuData[0].screenletActionIconsSyspkArray ? currentMenuData[0].screenletActionIconsSyspkArray : []
      //let screenletListboxSyspkArray = currentMenuData[0].screenletListboxSyspkArray
      let screenletListboxSyspkArray = currentMenuData[0].screenletListboxSyspkArray ? currentMenuData[0].screenletListboxSyspkArray : []
      let currentMenuActionIconsData = actionIconsData.filter(r => screenletActionIconsSyspkArray.includes(r.syspk))
      let currentMenuListboxData = listboxData.filter(r => screenletListboxSyspkArray.includes(r.syspk))

      this.screenletListboxDefault = currentMenuData[0].screenletListboxDefaultValue
      this.screenletCardStyle = currentMenuData[0].screenletCardStyle


      function sortFuncLB(a, b) {

        return screenletListboxSyspkArray.indexOf(a.syspk) - screenletListboxSyspkArray.indexOf(b.syspk);
      }

      function sortFuncAI(a, b) {

        return screenletActionIconsSyspkArray.indexOf(a.syspk) - screenletActionIconsSyspkArray.indexOf(b.syspk);
      }

      currentMenuListboxData.sort(sortFuncLB); //sorting the currentMenuListboxData
      currentMenuActionIconsData.sort(sortFuncAI); //sorting the currentMenuActionIconsData

      this.currentMenuActionIconsData = currentMenuActionIconsData //need to add in router function
      this.currentMenuListboxData = currentMenuListboxData
      this.screenletListboxCount = currentMenuListboxData.length
      this.dateRangeFilterFlag = currentMenuData[0].dateRangeFilterDisplayFlag
      this.dateRangeFilterShortcuts = currentMenuData[0].dateRangeFilterShortcuts
      this.orderbyTextJson = currentMenuData[0].orderbyTextJson
      let currentMenuListboxSQLId = currentMenuData[0].screenletListbox1_sqlId
      this.screenletListboxType = currentMenuData[0].screenletListboxType
      if (currentMenuListboxSQLId) {
        await this.fetchListboxData(currentMenuListboxSQLId);
      }


      function dateRangeCalc(date1, interval, dateType) {
        switch (dateType) {
          case 'month': {
            let firstDay = new Date(date1.getFullYear(), date1.getMonth() - interval, 1);
            let lastDay = new Date(date1.getFullYear(), date1.getMonth(), 0);
            return [firstDay, lastDay];
          }
          case 'day': {
            let firstDay = new Date();
            let dateOffset = (24 * 60 * 60 * 1000) * interval; //5 days
            let lastDay = new Date();
            firstDay.setTime(firstDay.getTime() - dateOffset);
            lastDay.setTime(lastDay.getTime());
            return [firstDay, lastDay];
          }
          case 'hour': {
            let firstDay = new Date();
            let dateOffset = (interval * 60 * 60 * 1000); //5 days
            let lastDay = new Date();
            firstDay.setTime(firstDay.getTime() - dateOffset);
            lastDay.setTime(lastDay.getTime());
            return [firstDay, lastDay];
          }
        }
      }

      //let shortcuts = []
      for (let key in this.dateRangeFilterShortcuts) {
        let value = this.dateRangeFilterShortcuts[key];
        for (let inKey in value) {
          let shortcut = {
            'text': key,
            onClick() {
              return dateRangeCalc(new Date(), value[inKey], inKey)
            }
          }
          this.shortcuts.push(shortcut)
        }
      }
      currentMenuListboxData.forEach((cmld, index) => {
        console.log("cmld", cmld);
        let bizNamefilterdim = columnMetadata.filter(c => c.columnName === cmld.listboxDimName);

        this.$set(this.screenletListboxDim, index, cmld.listboxDimName);
        this.$set(this.SLlistboxDimBizName, index, bizNamefilterdim[0]?.bizName || null);
      });

      this.filter = {...this.applyScreenletListboxDefault}

      if (this.menuPath !== '/post-load') {
        await this.loadSummary(this.filter);
      }
    }
    ,

    sortBy: function (sortKey) {
      this.reverse = (this.sortKey === sortKey) ? !this.reverse : false;
      this.sortKey = sortKey;
    }
    ,
    makeWidth: function (r, c) {
      let v0 = this.vizDataRowCol[r][c][0].vizunitWidthArray
      let defV = ['2', '4', '5']
      let v = v0 && v0.length > 0 ? v0 : defV
      let lg = v[2]
      let w = ""
      let isMobile = window.innerWidth < 400
      if (isMobile) w = `width: 100%`
      else w = `width: ${lg * 10 - 5}%`
      return w
    }
    ,
    loadSummary: async function (x) {

      // Increment the key to force Vue to re-create the iframe
      this.iframeKey += 1;
      console.log("filterType", x, JSON.stringify(this.filter));
      console.log("authToken", this.authToken)

      //toggle button color when submitting
      if (document.getElementById("button")) {
        let element = document.getElementById("button");
        element.classList.remove("btn-warning")
        element.classList.add("btn-success");

      }

      await this.$store.dispatch("loadState")
      // let allVizData = this.$store.state.fwConfigScreenElement
      // console.log("allVizData",allVizData)

    }
    ,
    listenToRouter: function () {
      console.log("listenToRouter is called")
      let $this = this
      this.$router.afterEach(function (from, to) {
        console.log(`router moved to ${from.path} from ${to.path}`)
        $this.rows = []
        $this.screenletListboxDim = {}
        $this.screenletListboxCount = null
        $this.optionValues = []
        $this.isOpenCoursel = false
        $this.messages = []
        //$this.x = {"d3l1_name":"All","d6l1_name":"All"},//need to revisit to make it dynamic
        $this.x = {}//revisited and made dynamic
        $this.y = {}
        $this.filter = {}
        $this.time3 = ''
        setTimeout(() => {
          $this.loadListbox()
          // $this.loadSummary($this.x)
        }, 300)

      })
    }
    ,
    sortDateRelatedObjects(listBoxOptions) {
      // Clone the object to avoid mutating the original
      const sortedOptions = {...listBoxOptions};

      for (const key in sortedOptions) {
        const values = sortedOptions[key];
        if (Array.isArray(values)) {
          // Sort date-related values in descending order
          sortedOptions[key] = values.sort((a, b) => {
            const isADate = this.isDateRelated(a);
            const isBDate = this.isDateRelated(b);

            // Both are date-related, sort by date in descending order
            if (isADate && isBDate) {
              return this.parseDate(b) - this.parseDate(a);
            }

            // if (!this.isDateRelated(a) || !this.isDateRelated(b)) return 0;

            const monthPattern = /^(jan(uary)?|feb(ruary)?|mar(ch)?|apr(il)?|may|jun(e)?|jul(y)?|aug(ust)?|sep(tember)?|oct(ober)?|nov(ember)?|dec(ember)?)$/i;

            // Special case: Month names (case insensitive)
            if (monthPattern.test(a) && monthPattern.test(b)) {
              const monthOrder = ["jan", "feb", "mar", "apr", "may", "jun", "jul", "aug", "sep", "oct", "nov", "dec"];
              const aNormalized = a.slice(0, 3).toLowerCase(); // Normalize to lowercase
              const bNormalized = b.slice(0, 3).toLowerCase();
              return monthOrder.indexOf(bNormalized) - monthOrder.indexOf(aNormalized);
            }

            // One is date-related and the other is not
            if (isADate) {
              return -1; // Move date-related items to the front
            }

            if (isBDate) {
              return 1; // Move date-related items to the front
            }

            // Both are not date-related, sort alphabetically or numerically
            if (typeof a === 'string' && typeof b === 'string') {
              return a.localeCompare(b); // Ascending order for strings
            } else if (typeof a === 'number' && typeof b === 'number') {
              return a - b; // Ascending order for numbers
            }

            // Handle mixed data types (string vs number)
            return (typeof a < typeof b) ? -1 : 1; // Strings before numbers
          });
        }
      }

      return sortedOptions;
    }
  }
}
</script>
<style scoped>
.banner-true {
  height: 86vh;
  @media (max-width: 1300px) {
    max-height: 84vh;
  }
}

.banner-false {
  height: 93vh;
  @media (max-width: 1300px) {
    height: 92vh;
  }
}
.fixed-screen-width {
  @media (min-width: 576px) {
    width: 55vw;
  }
}

.back-button {
  background: none;
  border: none;
  font-size: 0.8rem;
  cursor: pointer;
  margin-right: 10px; /* Adjust margin as needed */
}

.card-body {
  padding: 0;
}

.card-body .card-deck .card {
  margin: 0 !important;
}

.anyWhichWay {
  background: #c7f0c3; /* #89fb85  daf0d9 */
}

.freeForm {
  background: #91bbf0;
}

.h1tag {
  font-size: 20px;
  margin-bottom: 0px;
}

.lists {
  margin-top: -15px;
}


@media (max-width: 1500px) and (min-width: 1301px) {
  .my-custom-tooltip .tooltip-inner {
    width: 950px; /* Adjust as needed for smaller screens */
    font-size: 16px;
  }

  .h1tag {
    font-size: 18px;
  }

}


@media (max-width: 1300px) and (min-width: 1251px) {
  .my-custom-tooltip .tooltip-inner {
    width: 920px; /* Adjust as needed for smaller screens */
    font-size: 16px;
  }

  .h1tag {
    font-size: 18px;
  }

}

@media (max-width: 1250px) and (min-width: 1201px) {
  .my-custom-tooltip .tooltip-inner {
    width: 870px; /* Adjust as needed for smaller screens */
    font-size: 16px;
  }

  .h1tag {
    font-size: 18px;
  }

}

@media (max-width: 1200px) and (min-width: 1151px) {
  .my-custom-tooltip .tooltip-inner {
    width: 820px; /* Adjust as needed for smaller screens */
    font-size: 16px;
  }

  .h1tag {
    font-size: 18px;
  }

}

@media (max-width: 1150px) and (min-width: 1101px) {
  .my-custom-tooltip .tooltip-inner {
    width: 770px; /* Adjust as needed for smaller screens */
    font-size: 16px;
  }

  .h1tag {
    font-size: 18px;
  }

}

@media (max-width: 1100px) and (min-width: 1051px) {
  .my-custom-tooltip .tooltip-inner {
    width: 720px; /* Adjust as needed for smaller screens */
    font-size: 16px;
  }

  .h1tag {
    font-size: 18px;
  }

}

@media (max-width: 1050px) and (min-width: 1001px) {
  .my-custom-tooltip .tooltip-inner {
    width: 670px; /* Adjust as needed for smaller screens */
    font-size: 16px;
  }

  .h1tag {
    font-size: 18px;
  }

}


@media (max-width: 1000px) and (min-width: 951px) {
  .my-custom-tooltip .tooltip-inner {
    width: 620px; /* Adjust as needed for smaller screens */
    font-size: 16px;
  }

  .h1tag {
    font-size: 18px;
  }

}

@media (max-width: 950px) and (min-width: 901px) {
  .my-custom-tooltip .tooltip-inner {
    width: 570px; /* Adjust as needed for smaller screens */
    font-size: 16px;
  }

  .h1tag {
    font-size: 18px;
  }

}

@media (max-width: 900px) and (min-width: 851px) {
  .my-custom-tooltip .tooltip-inner {
    width: 520px; /* Adjust as needed for smaller screens */
    font-size: 16px;
  }

  .h1tag {
    font-size: 18px;
  }
}

@media (max-width: 850px) and (min-width: 801px) {
  .my-custom-tooltip .tooltip-inner {
    width: 470px; /* Adjust as needed for smaller screens */
    font-size: 16px;
  }

  .h1tag {
    font-size: 18px;
  }
}

@media (max-width: 800px) and (min-width: 768px) {
  .my-custom-tooltip .tooltip-inner {
    width: 430px; /* Adjust as needed for smaller screens */
    font-size: 16px;
  }

  .h1tag {
    font-size: 18px;
  }


}


@media (max-width: 768px) and (min-width: 751px) {
  .my-custom-tooltip .tooltip-inner {
    width: 650px; /* Adjust as needed for smaller screens */
    font-size: 16px;
  }

  .h1tag {
    font-size: 18px;
  }

}

@media (max-width: 750px) and (min-width: 701px) {
  .my-custom-tooltip .tooltip-inner {
    width: 600px; /* Adjust as needed for smaller screens */
    font-size: 16px;
  }

  .h1tag {
    font-size: 18px;
  }

}

@media (max-width: 700px) and (min-width: 651px) {
  .my-custom-tooltip .tooltip-inner {
    width: 550px; /* Adjust as needed for smaller screens */
    font-size: 16px;
  }

  .h1tag {
    font-size: 18px;
  }

}

@media (max-width: 650px) and (min-width: 601px) {
  .my-custom-tooltip .tooltip-inner {
    width: 500px; /* Adjust as needed for smaller screens */
    font-size: 16px;
  }

  .h1tag {
    font-size: 18px;
  }

}

@media (max-width: 600px) and (min-width: 551px) {
  .my-custom-tooltip .tooltip-inner {
    width: 450px; /* Adjust as needed for smaller screens */
    font-size: 16px;
  }

  .h1tag {
    font-size: 18px;
  }

}

@media (max-width: 550px) and (min-width: 481px) {
  .my-custom-tooltip .tooltip-inner {
    width: 370px; /* Adjust as needed for smaller screens */
    font-size: 16px;
  }

  .h1tag {
    font-size: 18px;
  }

}

@media (max-width: 480px) {
  .my-custom-tooltip .tooltip-inner {
    width: 350px; /* Further reduce the width for very small screens */
    font-size: 16px; /* Further adjust font size for very small screens */
  }

  .h1tag {
    font-size: 18px;
  }

}


.select-store-msg {
  padding: 15px;
  padding-top: 80px;
  display: flex;
  flex-direction: column;
  width: 360px;
  height: 266px;
  background-color: aliceblue;
  margin-left: auto;
  margin-right: auto;
  border-radius: 30px;
  align-items: center;
  @media (max-width: 540px) {
    width: 90%;
  }
  @media (min-width: 541px) {
    width: 360px;
  }
}
p{

  font-size: 18px;
  text-align: center;
}



</style>
<!--<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>-->